import baseURL from "../common/axios";
class commonService {
  GetCountry() {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get("/Common/CountryList");
  }

  GetStateByCountryId(CountryId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "/Common/GetStateByCountryId?CountryId=" + CountryId + ""
    );
  }

  GetCityByStateId(StateId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "/Common/GetCityByStateId?StateId=" + StateId + ""
    );
  }

  // file upload api call
  fileupload(formdata) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.post("UploadImages/UploadImages", formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  // file upload All filesapi call
  fileuploadAll(formdata) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.post("UploadImages/UploadFile", formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  getCodeTemplate(data) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/GetCode?EntityId=" +
      data.EntityId +
      "&HospitalId=" +
      data.HospitalId +
      "&BranchId=" +
      data.BranchId +
      ""
    );
  }

  CodeTemplateList(BranchId, OrganizationId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/GetCodeTemplateList?BranchId=" +
      BranchId +
      "&OrganizationId=" +
      OrganizationId +
      ""
    );
  }

  CreateCodeTemplate(CodeTemplateList) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.post(
      "Common/CreateCodeTemplate",
      CodeTemplateList
    );
  }

  EntityListData() {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get("EntityMaster/List");
  }

  userMasterList() {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get("Common/userMasterList");
  }

  departmentByUserId(userid) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/DepartmentByUserId?UserId=" + userid + ""
    );
  }

  userMasterByUserId(userid) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/UserMasterByUserId?UserId=" + userid + ""
    );
  }

  LoadHMSTaskType(ClientId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/GetAllTaskTypeList?ClientId=" + ClientId + ""
    );
  }

  GetTaskTypeList(ServiceType) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/GetTaskTypeList?ServiceType=" + ServiceType + ""
    );
  }

  LoadOrganizationList() {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get("Common/OrganizationList");
  }

  LoadBranchList() {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get("Common/BranchList");
  }

  LoadDepartmentList() {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get("Common/DepartmentList");
  }

  LoadSubDepartmentList() {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get("Common/SubDepartmentList");
  }

  LoadOrganizationConfigList() {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get("Common/OrganizationConfigList");
  }

  DoctorList(ClientId, BranchId, DepartmentId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/GetDoctorNameList?ClientId=" +
      ClientId +
      "&BranchId=" +
      BranchId +
      "&DepartmentId=" +
      DepartmentId +
      ""
    );
  }

  SpecialityList(ClientId, DoctorId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/GetDoctorSpecialtyList?ClientId=" +
      ClientId +
      "&DoctorId=" +
      DoctorId +
      ""
    );
  }

  GetAreaList(Id) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/PinCodeList?OfficeName=" + Id + ""
    );
  }

  GetHMSDepartmentList(Id) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/HMSDepartmentList?ClientId=" + Id + ""
    );
  }

  LoadHMSPatientList(ClientId, PhoneNumber) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/HMSPatinetList?ClientId=" +
      ClientId +
      "&PhoneNumber=" +
      PhoneNumber +
      ""
    );
  }

  LoadHMSPatientVisitList(ClientId, PatientId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Common/HMSPatinetVisitList?ClientId=" +
      ClientId +
      "&PatientId=" +
      PatientId +
      ""
    );
  }

  GetModulesByOrganizationId(OrganizationId) {
    return baseURL.httpMSMOPCRMUrl.get("Common/GetModulesByOrganizationId?OrganizationId=" + OrganizationId);
  }
}

export default new commonService();
